import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  makeStyles
} from '@material-ui/core';
import Page from 'src/components/Page';
import SessionContext from 'src/libs/SessionContext';
import { adminGetCustomerInfoByUser } from 'src/libs/AdminServices';
import Results from './Results';
import Toolbar from './Toolbar';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const CustomerListView = () => {
  const classes = useStyles();
  const { userSession, setUserSession } = React.useContext(SessionContext);
  const [customers, setCustomers] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await adminGetCustomerInfoByUser();
        if (res && res.status === 200) {
          console.log(res);
          setCustomers(res.customers);
        } else if (res.status === 401) {
          alert('Sorry, your session has expired. Please log in again.');
          setUserSession({ ...userSession, isAuthenticated: false });
          sessionStorage.clear();
        }
        setIsLoading(false);
      } catch (e) {
        console.log(e);
        setIsLoading(false);
      }
    }

    fetchData();
  }, []);

  return (
    !isLoading && (
      <Page
        className={classes.root}
        title="Customers"
      >
        <Container maxWidth={false}>
          <Toolbar />
          <Box mt={3}>
            <Results customers={customers} />
          </Box>
        </Container>
      </Page>
    )
  );
};

export default CustomerListView;
